import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/architecture-integration-review/page.tsx");
